// Dates are handled as Paris wall-clock times, whatever the device timezone.
const toParisWall = (d) => new Date(d.toLocaleString("en-US", { timeZone: "Europe/Paris" }));

export const parisNow = () => toParisWall(new Date());

export const parseParis = (value) => {
  if (!value) return null;
  if (/[zZ]|[+-]\d{2}:\d{2}$/.test(value)) return toParisWall(new Date(value));
  const [d, t = "00:00:00"] = value.split("T");
  const [y, m, day] = d.split("-").map(Number);
  const [h, mi] = t.split(":").map(Number);
  return new Date(y, m - 1, day, h, mi);
};

const pad = (n) => String(n).padStart(2, "0");

export const formatParis = (d) =>
  d ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:00` : null;
